import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import styles from './Checkbox.module.scss';

export const Checkbox = props => {
  const {
    className = 'px-2',
    checkboxClassName,
    name = 'check',
    label,
    id,
    labelTpl = <span>{label}</span>,
    error,
    ...other
  } = props;

  return (
    <div className={clsx(styles.checkboxWrapper, className)}>
      <label htmlFor={id} className={styles.labelContainer}>
        <input id={id} name={name} type="checkbox" className={styles.invisible} {...other} />
        <div className={styles.checkbox}>
          <svg width="20px" height="20px" viewBox="0 0 20 20">
            <path
              d="M3,1 L17,1 L17,1 C18.1045695,1 19,1.8954305 19,3 L19,17 L19,17 C19,18.1045695 18.1045695,19 17,19 L3,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,3 L1,3 C1,1.8954305 1.8954305,1 3,1 Z"/>
            <polyline points="4 11 8 15 16 6"/>
          </svg>
        </div>
        <span>{labelTpl}</span>
      </label>
    </div>
  )
};

Checkbox.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  radioClassName: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool
};

export default Checkbox;
